import { get } from 'lodash'

export const loadMoreRowsHandler =
  ({ page, loadMore, setPage, overscanRowCount, listMeta, promiseQueue }) =>
  ({ stopIndex }) => {
    const scrolledPage = Math.floor(stopIndex / overscanRowCount)
    const lastLoadedPage = get(listMeta, 'page')
    const currentPage = lastLoadedPage > page ? lastLoadedPage : page

    if (page < scrolledPage) {
      const nextPage = currentPage + 1

      for (let i = nextPage; i <= scrolledPage; i++) {
        promiseQueue.push(() => loadMore({ page: i }))
      }

      setPage(scrolledPage)
    }
  }
